import { Component } from '@angular/core';
import { ClarifyChallengeComponent } from '../clarify-challenge.component';
import { CnAiService } from '../../challenges_service/cn-ai.service';

@Component({
  selector: 'app-clarify-sub-challenge',
  templateUrl: './clarify-sub-challenge.component.html',
  styleUrls: ['./clarify-sub-challenge.component.scss']
})
export class ClarifySubChallengeComponent {
  constructor(public clarifyChallengeComponent: ClarifyChallengeComponent, private aiService: CnAiService) {}

  openAiSidebar() {
    const context = this.clarifyChallengeComponent?.question_content || [];
    this.aiService.openSidebar(
      'clarify', 'challenge', context,
      'Generate 5 challenge questions {persona} to reframe the problem. Current context: {context}',
      'dupli_question_content', this.clarifyChallengeComponent
    );
  }
}
